import * as ACTION_TYPES from '../types';

let initialState = {
  qrcodeList: [],
  qrcode: {}
}

export default (state = initialState, action) => {
    switch (action.type) {

      case ACTION_TYPES.GET_QRCODES:
        return {...state, qrcodeList: action.data };

      case ACTION_TYPES.GET_QRCODE_BY_ID:
        return {...state, qrcode: action.data};

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_MATERIALS:
        return {...state, qrcodeList: []};

      default:
        return state;
    }
  };